import React from "react";
import { useLocale } from "next-intl";
import { ArrowLeft, ArrowRight } from "lucide-react";

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  wide?: boolean;
  leftArrow?: boolean;
  fill?: "white" | "primary" | "transparent";
};

const Button = ({
  children,
  className = "",
  wide = false,
  leftArrow = false,
  fill = "primary",
  disabled = false,
  ...props
}: ButtonProps) => {
  const locale = useLocale();

  const isTransparent = fill === "transparent";

  const baseClasses =
    "rounded-lg py-3 flex items-center gap-2 font-medium overflow-hidden relative transition-colors duration-200 select-none";

  const layoutClasses = `${wide ? "min-w-40" : ""} ${
    isTransparent ? "justify-start" : "justify-center px-5"
  }`;

  const stateClasses = disabled
    ? isTransparent
      ? "bg-transparent text-text-disabled cursor-not-allowed"
      : "bg-text-disabled text-white cursor-not-allowed"
    : isTransparent
    ? "bg-transparent text-primary cursor-pointer hover:underline"
    : fill === "white"
    ? "button-white text-primary cursor-pointer"
    : "button-primary text-white cursor-pointer";

  return (
    <button
      className={`${baseClasses} ${layoutClasses} ${stateClasses} ${className}`}
      disabled={disabled}
      {...props}
    >
      {children}
      {leftArrow &&
        (locale === "en" ? (
          <ArrowRight className="button-arrow-l w-4 h-5 text-current" />
        ) : (
          <ArrowLeft className="button-arrow-r w-4 h-5 text-current" />
        ))}
    </button>
  );
};

export default Button;
